exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "h5[data-v-82f9d0a0]{font-size:1.5rem;color:#333;margin-bottom:15px;font-weight:600;border-bottom:2px solid #2d5c88;padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-82f9d0a0","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/MatchingBulkClient.vue
// module id = 204
// module chunks = 0